import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uv-tile-subtitle" }

import { computed } from 'vue';
	import { IVehicle } from '@/types';
	

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle
	}

	

	const gradeItemName = computed(() => {
		var finalName = props.vehicle.Grade;
		if (finalName != ""){
			if (props.vehicle.DriveType != ""){
				finalName += " - " + props.vehicle.DriveType;
			}
		}
		else {
			finalName = props.vehicle.DriveType;
		}
		return finalName;
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(gradeItemName)), 1))
}
}

})